
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import './shared-store.js';
import { s as sharedStore } from '../../../_virtual/shared-store.js';

var store = sharedStore.exports;

var shared = function (key, value) {
  return store[key] || (store[key] = value || {});
};

export { shared as default };
//# sourceMappingURL=shared.js.map
